import { useQuery } from '@tanstack/react-query';

import solomonService from 'services/solomonService';

import type { SolomonRecommendationsResponse, SolomonPageContext } from '../../types/solomon';

interface UseSolomonRecommendationsProps {
  artistId: string;
  pageContext: SolomonPageContext;
  currentState: Record<string, unknown>;
  artistName?: string;
  enabled?: boolean;
  queryKeySuffix?: string;
}

export function useSolomonRecommendations({
  artistId,
  pageContext,
  currentState,
  artistName,
  enabled = true,
  queryKeySuffix = '',
}: UseSolomonRecommendationsProps) {
  // Create a stable hash of the data for the query key
  const dataHash = JSON.stringify(currentState);

  return useQuery<SolomonRecommendationsResponse>({
    queryKey: ['solomon-recommendations', artistId, pageContext, queryKeySuffix, dataHash],
    queryFn: () => {
      return solomonService.getRecommendations({
        artistId,
        pageContext,
        currentState,
        artistName,
      });
    },
    enabled: enabled && !!artistId && !!currentState && Object.keys(currentState).length > 0,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 15 * 60 * 1000, // 15 minutes cache
    retry: 1,
  });
}

export default useSolomonRecommendations;
